import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { withLocalize, Translate } from "react-localize-redux";
import Clients from '../clients/Clients';
import ClientPage from '../client/Client';

var clientTranslations = require("../../translations/client.json")

class ClientsRouter extends React.Component<any, any> {
  constructor(props:any) {
    super(props)
    this.props.addTranslation(clientTranslations)
  }


  public render() {
    return (
      <div id="clients-router-root">
        <div className="buttonsHeader">
          <Link to="/clients/new"><button><Translate id="client.newClient" /></button></Link>
        </div>

        <Switch>
          <Route exact path={`/clients`} component={Clients} />
          <Route exact path={`/clients/new`} component={ClientPage} />
          <Route exact path={`/clients/:id`} component={ClientPage} />
        </Switch>

      </div>
    );
  }
}

export default withLocalize(ClientsRouter)



// WEBPACK FOOTER //
// ./src/pages/home/ClientsRouter.tsx